import React, { useEffect, useState } from "react";
import "./Receipt.css";
import { FaSearch } from "react-icons/fa";
import Header from "../Header/Header";
import { useNavigate } from "react-router-dom";
import "../Home/Home.css";
import InfiniteScroll from "react-infinite-scroll-component";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import axios from "axios";

const Receipt = () => {
  const navigate = useNavigate();
  const [expenses, setExpenses] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [expandedExpense, setExpandedExpense] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("tokenexpense");
    if (!token) {
      navigate("/welcome");
    } else {
      fetchExpenses(token, 1);
    }
  }, [navigate]);

  const fetchExpenses = async (token, currentPage) => {
    try {
      const response = await axios.get(
        `https://expense.dpstrust.in/api/expense/all?page=${currentPage}&limit=10`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status) {
        const newExpenses = response.data.data.expenses;

        // Filter out duplicates
        const uniqueExpenses = Array.from(
          new Map(
            [...expenses, ...newExpenses].map((item) => [item._id, item])
          ).values()
        );

        setExpenses(uniqueExpenses);
        if (newExpenses.length < 10) {
          setHasMore(false); // No more pages to load
        }
      }
    } catch (error) {
      console.error("Error fetching expenses:", error);
      setHasMore(false); // Stop loading on error
    }
  };

  const loadMoreExpenses = () => {
    const token = localStorage.getItem("tokenexpense");
    const nextPage = page + 1;
    setPage(nextPage);
    fetchExpenses(token, nextPage);
  };

  const toggleExpenseExpansion = (id) => {
    setExpandedExpense(expandedExpense === id ? null : id);
  };

  const userInitials = localStorage.getItem("userInitials");



  return (
    <>
      <Header heading="Receipt" />

      <div className="receipt-container">
      {expenses.length === 0 && !hasMore && (
    <p style={{ textAlign: "center", color: "red" }}>No expenses available</p>
  )}
 
  <InfiniteScroll
    dataLength={expenses.length}
    next={loadMoreExpenses}
    hasMore={hasMore}
    loader={<h4>Loading more expenses...</h4>}
    endMessage={
      expenses.length > 0 ? (
        <p style={{ textAlign: "center" }}>No more expenses</p>
      ) : null
    }
  >
            <ul className="home-list">
          {expenses?.map((item) => (<>
            <li
              key={item?._id}
              className="home-item"
            >
              <div className="contlist">
              {(item?.receiptFrontSideImage || item?.receiptBackSideImage || item?.description || item?.date) && (
  expandedExpense === item?._id ? (
    <IoIosArrowUp
      style={{ color: "#000", marginRight:"10px" }}
      onClick={() => toggleExpenseExpansion(item._id)}
    />
  ) : (
    <IoIosArrowDown
      style={{ color: "#000", marginRight:"10px" }}
      onClick={() => toggleExpenseExpansion(item._id)}
    />
  )
)} 
              <div className="home-image">{userInitials}</div>
              <div className="home-details">
                <div className="home-title" style={{ textTransform: "capitalize" }}>{item?.category}</div>
                <div className="home-date">{item?.description}</div>
              </div>
              <div className="home-price">₹ {item?.amount}</div>
              </div>
              <div className="home-datelow">
  {/* {new Date(item.date).toLocaleDateString()} */}
  {/* {(item.receiptFrontSideImage || item.receiptBackSideImage) && (
  expandedExpense === item?._id ? (
    <IoIosArrowUp
      style={{ color: "#000" }}
      onClick={() => toggleExpenseExpansion(item._id)}
    />
  ) : (
    <IoIosArrowDown
      style={{ color: "#000" }}
      onClick={() => toggleExpenseExpansion(item._id)}
    />
  )
)} */}
</div>
             
              {expandedExpense === item._id && (
  <div className="expense-details">
  
  {item.description && (
      <div style={{display:"flex", width:"100%"}}>
        <strong style={{width:"140px"}}>Description:</strong>
        <span style={{width:"200px", height:"auto", marginBottom:"10px"}}
        >{item?.description}
          </span>
      </div>
    )}
    {item.date && (
      <div style={{display:"flex", width:"100%"}}>
        <strong style={{width:"140px"}}>Date:</strong>
        <span style={{width:"200px", height:"auto", marginBottom:"10px"}}
        >{new Date(item.date).toLocaleDateString()}
          </span>
      </div>
    )}
    {item.receiptFrontSideImage && (
      <div style={{display:"flex", width:"100%"}}>
        <strong style={{width:"140px"}}>Receipt (Front):</strong>
        <img style={{width:"200px", height:"auto"}}
          // src="./card.png"
          src={item.receiptFrontSideImage}
          alt="Receipt Front"
          className="receipt-image"
        />
      </div>
    )}
    {item.receiptBackSideImage && (
      <div style={{display:"flex", width:"100%"}}>
        <strong style={{width:"140px"}}>Receipt (Back):</strong>
        <img style={{width:"200px", height:"auto"}}
                  // src="./card.png"
          src={item.receiptBackSideImage}
          alt="Receipt Back"
          className="receipt-image"
        />
      </div>
    )}
</div>
)}

            </li>
            </>
          ))}
        </ul>
  </InfiniteScroll>
      </div>
    </>
  );
};

export default Receipt;
